// 关于时间的函数和配置
// 获取当前时间
/**
 * 格式化时间
 * */
export function format(data){
    const now = new Date(data)
    const day = now.getDate()<10?`0${now.getDate()}`:now.getDate()
    const month = now.getMonth()<9?`0${now.getMonth()+1}`:`${now.getMonth()+1}`
    const year = now.getFullYear()
    const min = now.getMinutes()<10?`0${now.getMinutes()}`:`${now.getMinutes()}`
    const sec = now.getSeconds()<10?`0${now.getSeconds()}`:`${now.getSeconds()}`
    const hour = now.getHours()<10?`0${now.getHours()}`:`${now.getHours()}`
    return {year:year,month:month,day:day,hour:hour,sec:sec,min:min}

}
/**
 * 获取当前时间
 * */
export function getNow(){
    const now = new Date()
    const day = now.getDate()<10?`0${now.getDate()}`:now.getDate()
    const month = now.getMonth()<9?`0${now.getMonth()+1}`:`${now.getMonth()+1}`
    const year = now.getFullYear()
    const min = now.getMinutes()
    const sec = now.getSeconds()
    const hour = now.getHours()
    return {year:year,month:month,day:day,hour:hour,sec:sec,min:min}
}

/**
 * / 获取时间 年的分隔符和月的分隔符
 */
export function getNowSpite(spa1='-',spa2=":"){
    const now = new Date()
    const day = now.getDate()<10?`0${now.getDate()}`:now.getDate()
    const month = now.getMonth()<9?`0${now.getMonth()+1}`:`${now.getMonth()+1}`
    const year = now.getFullYear()
    const min = now.getMinutes()<10?`0${now.getMinutes()}`:`${now.getMinutes()}`
    const sec = now.getSeconds()<10?`0${now.getSeconds()}`:`${now.getSeconds()}`
    const hour = now.getHours()<10?`0${now.getHours()}`:`${now.getHours()}`
    return `${year}${spa1}${month}${spa1}${day} ${hour}${spa2}${min}${spa2}${sec}`
}


/**
 * 获取时间
 * today:当天
 * tomorrow：明天
 * currentWeek：本周
 * currentMonth：本月
 * @param classify
 * @returns {[Date,Date]}
 */
export function getDateTime(classify){
    const today = new Date()
    let year,month,date,day,start,end,stY,stM,stD,edY,edM,edD,weekSt,weekEd
    const tomorrow = new Date(today.getTime() + 24*60*60*1000)
    year = today.getFullYear(); //获取完整的年份(4位)
    month = today.getMonth()+1; //获取当前月份(0-11,0代表1月)
    date = today.getDate(); //获取当前日(1-31)
    switch (classify){
        case "today":
            stY = edY =  year
            stM = edM = month
            stD = edD = date
            break
        case "tomorrow":
            stY = edY =  tomorrow.getFullYear(); //获取完整的年份(4位)
            stM = edM = tomorrow.getMonth()+1; //获取当前月份(0-11,0代表1月)
            stD = edD = tomorrow.getDate(); //获取当前日(1-31)
            break
        case "currentWeek":
            day = today.getDay()===0?7:today.getDay(); //获取当前星期X(0-6,0代表星期天)
            weekSt = new Date(today.getTime() - (day-1)*24*60*60*1000)
            weekEd = new Date(today.getTime() + (7-day)*24*60*60*1000)
            stY = weekSt.getFullYear(); //获取完整的年份(4位)
            stM = weekSt.getMonth()+1; //获取当前月份(0-11,0代表1月)
            stD = weekSt.getDate(); //获取当前日(1-31)
            edY = weekEd.getFullYear(); //获取完整的年份(4位)
            edM = weekEd.getMonth()+1; //获取当前月份(0-11,0代表1月)
            edD = weekEd.getDate(); //获取当前日(1-31)
            break
        case "currentMonth":
            stY  = edY = year
            stM  = edM = month
            stD  = 1
            console.log(33,month,new Date(year, month, 0).getDate())
            edD = new Date(year, month, 0).getDate(); //获取当月最后一日
            break
    }
    // start =  new Date([stY,stM,stD].join("-"))
    // end = new Date([edY,edM,edD].join("-") )
    start =  [stY,stM,stD].join("-")
    end = [edY,edM,edD].join("-")
    return [start,end]
}
/**
 * 获取处理后的时间
 * */
export function formatTime(data){
    const now = new Date(data)
    const day = now.getDate()<10?`0${now.getDate()}`:now.getDate()
    const month = now.getMonth()<9?`0${now.getMonth()+1}`:`${now.getMonth()+1}`
    const year = now.getFullYear()
    const min = now.getMinutes()<10?`0${now.getMinutes()}`:`${now.getMinutes()}`
    const sec = now.getSeconds()<10?`0${now.getSeconds()}`:`${now.getSeconds()}`
    const hour = now.getHours()<10?`0${now.getHours()}`:`${now.getHours()}`
    // return {year:year,month:month,day:day,hour:hour,sec:sec,min:min}
    return `${year}-${month}-${day} ${hour}:${min}:${sec}`
}
/**
 * 获取是星期几
 * */
export function getDay(data){
    if(!data) return
    const day = new Date(data).getDay()
    let dayD;
    switch (day){
        case 1:
            dayD =  "星期一"
            break
        case 2:
            dayD = "星期二"
            break
        case 3:
            dayD = "星期三"
            break
        case 4:
            dayD =  "星期四"
            break
        case 5:
            dayD =  "星期五"
            break
        case 6:
            dayD =  "星期六"
            break
        case 7:
            dayD =  "星期天"
            break
    }
    return dayD;
}
/**获取格式化的日期和时间*/
export function formatDateAndTime(data){
    if(!data){
        return ["",""]
    }
    const now = new Date(data)
    const day = now.getDate()<10?`0${now.getDate()}`:now.getDate()
    const month = now.getMonth()<9?`0${now.getMonth()+1}`:`${now.getMonth()+1}`
    const year = now.getFullYear()
    const min = now.getMinutes()<10?`0${now.getMinutes()}`:`${now.getMinutes()}`
    const sec = now.getSeconds()<10?`0${now.getSeconds()}`:`${now.getSeconds()}`
    const hour = now.getHours()<10?`0${now.getHours()}`:`${now.getHours()}`
    // return {year:year,month:month,day:day,hour:hour,sec:sec,min:min}
    return [`${year}-${month}-${day}`,`${hour}:${min}:${sec}`]
}



